const RegistButtonBox = ({ title = "등록", onClick }) => {
    return (
        <div className="btn-group">
            <button type="button" className="btn btn-common submit" onClick={(e) => onClick(e)}>
                {title}
            </button>
        </div>
    );
};

export default RegistButtonBox;
